import { useCallback, useRef } from "react";
import { useFolderTree } from "../../contexts/folderTree.js";
function useComposedRenameClose(handleRenameCancel) {
    const { onRenamePersist, onRenameStart, onRenameSuccess, onRenameError } = useFolderTree();
    const renameRef = useRef({
        onRenamePersist,
        onRenameStart,
        onRenameSuccess,
        onRenameError
    });
    renameRef.current = {
        onRenamePersist,
        onRenameStart,
        onRenameSuccess,
        onRenameError
    };
    return useCallback(async (save, inputValue, { id, title })=>{
        const { onRenamePersist: persist, onRenameStart: start, onRenameSuccess: success, onRenameError: error } = renameRef.current;
        if (!persist || id === undefined) {
            return;
        }
        if (save && inputValue.length && title !== inputValue) {
            const hide = start?.(inputValue);
            try {
                const displayName = await persist(id, inputValue, title);
                success?.(displayName);
                handleRenameCancel?.({}, {});
            } catch (renameError) {
                error?.(renameError);
            } finally{
                hide?.();
            }
        } else {
            handleRenameCancel?.({}, {});
        }
    }, [
        handleRenameCancel
    ]);
}
export { useComposedRenameClose };
